/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisRenderSequenceInfo
 * @hideconstructor
 * @classdesc Store the latest render sequence info and render task info
 */
define([
	'underscore',
	'./RenderTaskExecInfo'
], (_, RenderTaskExecInfo) => {
	class RenderSequenceInfo {
		constructor(options) {
			this._id = options.id;
			this._allTaskInfo = {};
		}

		getId(){
			return this._id;
		}

		addTaskInfo(taskInfo){
			let taskExecInfo = new RenderTaskExecInfo({ id: taskInfo.taskId });
			this._allTaskInfo[taskInfo.taskId] = taskExecInfo;
			return taskExecInfo;
		}

		getTaskInfo(taskId){
			return this._allTaskInfo[taskId];
		}

		toJSON(){
			return {
				'id': this._id,
				'tasks': _.values(this._allTaskInfo).map((value) => {return value.toJSON();})
			};
		}

	}
	return RenderSequenceInfo;
});